module.exports = __webpack_public_path__ + "img/krungsri.fcd07645.png";